import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

export default function RedirectRoute({ component: Component, ...rest }) {
  const { currentUser } = useAuth()

  return (
    <Route
      render={(props) => {
        return !currentUser ? <Redirect to="/login" /> : <Redirect to="/dashboard" />
      }}
    >
    </Route>
  )
}
